import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "../../../../redux/action";
import SettingRender from "./children/SettingRender";
import ChangePasswordModal from "./children/changePasswordModal/ChangePasswordModal";
import ForgotAndResetPasswordModal from "../../../forgotPasswordModal/ForgotAndResetPasswordModal";
import ChangeAppearanceModal from "./children/changeAppearanceModal/ChangeAppearanceModal";
import FeedbackModal from "./children/feedbackModal/FeedbackModal";
import ResultModal from "../../../resultModal/ResultModal";
import { GAPersonalSettingPageDisplay } from "../../../../ga/personalCenter";

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changePasswordModalVisible: false, //是否显示修改密码弹窗
      forgotPasswordModalVisible: false, //忘记密码弹窗控制显示变量
      changeAppearanceModalVisible: false, //修改editor主题弹窗
      feedbackModalVisible: false, //用户反馈弹窗
      resultModalObj: {}, //结果弹窗参数
    };
  }

  componentDidMount() {
    GAPersonalSettingPageDisplay();
  }

  /**
   * 控制修改密码弹窗的显示和关闭
   * @param {boolean} feedbackModalVisible 是否显示修改密码弹窗
   */
  handleFeedbackModalVisible = feedbackModalVisible => {
    if (feedbackModalVisible) {
      document.documentElement.style = "position: fixed;overflow: hidden;";
    } else {
      document.documentElement.style = "";
    }
    this.setState({
      feedbackModalVisible,
    });
  };

  /**
   * 控制修改密码弹窗的显示和关闭
   * @param {boolean} changePasswordModalVisible 是否显示修改密码弹窗
   */
  handleChangePasswordModalVisible = changePasswordModalVisible => {
    this.setState({
      changePasswordModalVisible,
    });
  };

  /**
   * 忘记密码弹窗的显示和关闭
   * @param {boolean} forgotPasswordModalVisible 是否显示修改密码弹窗
   */
  handleForgetPasswordModalVisible = forgotPasswordModalVisible => {
    this.setState({
      forgotPasswordModalVisible,
    });
  };

  /**
   *修改editor主题弹窗显示和关闭
   * @param {boolean} changeAppearanceModalVisible 是否显示修改主题弹窗
   */
  handleChangeAppearanceModalVisible = changeAppearanceModalVisible => {
    this.setState({
      changeAppearanceModalVisible,
    });
  };

  /**
   *修改结果弹窗的值
   * @param {object} resultModalObj
   */
  handleChangeResultObj = resultModalObj => {
    this.setState({
      resultModalObj,
    });
  };

  render() {
    console.log(this.state.resultModalObj);
    return (
      <>
        <SettingRender
          handleChangePasswordModalVisible={this.handleChangePasswordModalVisible}
          handleChangeAppearanceModalVisible={this.handleChangeAppearanceModalVisible}
          handleFeedbackModalVisible={this.handleFeedbackModalVisible}
        />
        {this.state.changePasswordModalVisible && (
          <ChangePasswordModal
            visible={this.state.changePasswordModalVisible}
            handleVisible={this.handleChangePasswordModalVisible}
            handleForgetPasswordModalVisible={this.handleForgetPasswordModalVisible}
          />
        )}
        {this.state.forgotPasswordModalVisible && (
          <ForgotAndResetPasswordModal visible={this.state.forgotPasswordModalVisible} handleVisible={this.handleForgetPasswordModalVisible} />
        )}
        {this.state.changeAppearanceModalVisible && (
          <ChangeAppearanceModal visible={this.state.changeAppearanceModalVisible} handleVisible={this.handleChangeAppearanceModalVisible} />
        )}
        {this.state.feedbackModalVisible && this.props.profileObj ? (
          <FeedbackModal
            visible={this.state.feedbackModalVisible}
            handleVisible={this.handleFeedbackModalVisible}
            handleChangeResultObj={this.handleChangeResultObj}
            email={this.props.profileObj.email}
          />
        ) : null}
        {this.state.resultModalObj.visible && (
          <ResultModal
            {...this.state.resultModalObj}
            onClose={() =>
              this.setState({
                resultModalObj: {},
              })
            }
          />
        )}
      </>
    );
  }
}

const mapStateToPropos = state => ({
  profileObj: state.account.profileObj,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(Setting);
